import { render, staticRenderFns } from "./display_detail.vue?vue&type=template&id=2f9e40b0&scoped=true"
import script from "./display_detail.vue?vue&type=script&lang=js"
export * from "./display_detail.vue?vue&type=script&lang=js"
import style0 from "./display_detail.vue?vue&type=style&index=0&id=2f9e40b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e40b0",
  null
  
)

export default component.exports